import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCashRegister } from "./cash-register-context";

/**
 * Se o caixa ficou aberto de um dia para o outro, força a rota de fechamento.
 */
export function CashRegisterGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { featureEnabled, loading, sessionExpired } = useCashRegister();

  useEffect(() => {
    if (!featureEnabled || loading) return;
    if (!sessionExpired) return;
    const path = location.pathname;
    if (path === "/login" || path.startsWith("/caixa/fechar")) return;
    navigate("/caixa/fechar", { replace: true });
  }, [
    featureEnabled,
    loading,
    sessionExpired,
    location.pathname,
    navigate,
  ]);

  return null;
}
